import { render, staticRenderFns } from "./UndoDeviation.vue?vue&type=template&id=48e491b8&scoped=true&"
import script from "./UndoDeviation.vue?vue&type=script&lang=js&"
export * from "./UndoDeviation.vue?vue&type=script&lang=js&"
import style0 from "./UndoDeviation.vue?vue&type=style&index=0&id=48e491b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e491b8",
  null
  
)

export default component.exports